module.exports = __webpack_public_path__ + "img/imgif.2ebfb0d4.gif";